// Central data-testid registry
export const NAV = {
  logo: "nav-logo-link",
  services: "nav-services-link",
  process: "nav-process-link",
  booking: "nav-booking-link",
  contact: "nav-contact-link",
  bookCta: "nav-book-cta",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  root: "hero-section",
  cta: "hero-book-cta",
  callBtn: "hero-call-btn",
};

export const SERVICES = {
  root: "services-section",
  card: (id) => `service-card-${id}`,
  cardBook: (id) => `service-card-book-${id}`,
};

export const BOOKING = {
  root: "booking-section",
  step: (n) => `booking-step-${n}`,
  next: "booking-next-btn",
  back: "booking-back-btn",
  submit: "booking-submit-btn",
  serviceSelect: (id) => `booking-service-${id}`,
  vehicleType: (id) => `booking-vehicle-${id}`,
  date: "booking-date-input",
  time: "booking-time-select",
  name: "booking-name-input",
  email: "booking-email-input",
  phone: "booking-phone-input",
  makeModel: "booking-makemodel-input",
  engineBay: "booking-engine-bay-toggle",
  notes: "booking-notes-input",
  success: "booking-success",
};

export const CONTACT = {
  root: "contact-section",
  name: "contact-name-input",
  email: "contact-email-input",
  phone: "contact-phone-input",
  subject: "contact-subject-input",
  message: "contact-message-input",
  submit: "contact-submit-btn",
  success: "contact-success",
};

export const ADMIN = {
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit",
  loginError: "admin-login-error",
  logout: "admin-logout-btn",
  tabBookings: "admin-tab-bookings",
  tabInquiries: "admin-tab-inquiries",
  bookingRow: (id) => `admin-booking-row-${id}`,
  inquiryRow: (id) => `admin-inquiry-row-${id}`,
  bookingStatusSelect: (id) => `admin-booking-status-${id}`,
  inquiryStatusSelect: (id) => `admin-inquiry-status-${id}`,
};

export const HOME = {
  emergentLink: "home-emergent-link",
};
